export const PROFESSIONAL_MALE_DEFAULT_IMAGE = '/static-appopensalud/img/bgs/opt/doctor-male-black.svg'
export const PROFESSIONAL_FEMALE_DEFAULT_IMAGE = '/static-appopensalud/img/bgs/opt/doctor-female-black.svg'
export const CENTER_DEFAULT_IMAGE = '/static-appopensalud/img/bgs/opt/center-black.svg'


// WEBPACK FOOTER //
// ./src/constants/images.js